// Decides whether a failed reminder server call (suppress, unsuppress, schedule sync) is expected
// (only logged) or must be reported. Kept out of notification.service.ts so it stays loadable under
// plain Node for its unit test, like locale-fetch-failure.ts.

import { wasReportedByCloudFunctions } from './cloud-functions-errors';
import { isOfflineOrTransientNetworkError } from './error-patterns';

/** Whether a rejection from a reminder cloud function needs no report of its own. Covers the
 * offline and native connectivity-loss shapes, and every failure the cloud-functions layer already
 * reported or deliberately left unreported because the phone was offline, such as an iOS native
 * request timeout (df-2a9e0a010140, Sentry CYBERNETIC-FITNESS-APP-4KZ). Anything else reached the
 * caller with nobody having reported it. */
export function isReminderServerFailureExpected(error: unknown): boolean {
  // if the device is offline or the connection dropped, losing the server call is the expected cost
  if (isOfflineOrTransientNetworkError(error)) return true;
  // if callApiAsync or callable() already filed the one report (or skipped it while offline),
  // a second report would be a duplicate
  return wasReportedByCloudFunctions(error);
}
